var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "m-portlet" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "m-portlet__body" },
        [
          _c(
            "el-form",
            {
              ref: "offerTemplatePart",
              attrs: {
                rules: _vm.rules,
                model: _vm.offerTemplatePart,
                "label-width": "200px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "type_id", label: "Kategorie" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "Bitte wählen" },
                      model: {
                        value: _vm.offerTemplatePart.type_id,
                        callback: function($$v) {
                          _vm.$set(_vm.offerTemplatePart, "type_id", $$v)
                        },
                        expression: "offerTemplatePart.type_id"
                      }
                    },
                    _vm._l(_vm.partTypes, function(item, key) {
                      return _c(
                        "el-option",
                        { key: key, attrs: { label: item, value: key } },
                        [_vm._v(_vm._s(item) + "\n                        ")]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Name", prop: "name" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.offerTemplatePart.name,
                      callback: function($$v) {
                        _vm.$set(_vm.offerTemplatePart, "name", $$v)
                      },
                      expression: "offerTemplatePart.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Überschrift" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.offerTemplatePart.headline,
                      callback: function($$v) {
                        _vm.$set(_vm.offerTemplatePart, "headline", $$v)
                      },
                      expression: "offerTemplatePart.headline"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.offerTemplatePart.type_id != 5
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "template", label: "Beschreibung" } },
                    [
                      _c("el-input", {
                        staticClass: "w-100",
                        attrs: { type: "textarea", rows: "15" },
                        model: {
                          value: _vm.offerTemplatePart.template,
                          callback: function($$v) {
                            _vm.$set(_vm.offerTemplatePart, "template", $$v)
                          },
                          expression: "offerTemplatePart.template"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Beschreibung in kurz" } },
                [
                  _c("el-input", {
                    staticClass: "w-100",
                    attrs: { type: "textarea", rows: "10" },
                    model: {
                      value: _vm.offerTemplatePart.template_short,
                      callback: function($$v) {
                        _vm.$set(_vm.offerTemplatePart, "template_short", $$v)
                      },
                      expression: "offerTemplatePart.template_short"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.offerTemplatePart.type_id == 5
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Preis Spalten" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.priceArr.priceCols,
                              callback: function($$v) {
                                _vm.$set(_vm.priceArr, "priceCols", $$v)
                              },
                              expression: "priceArr.priceCols"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("h4", { staticClass: "mt-3" }, [
                        _vm._v("Preisabstufungen")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-4" },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "Preis 1 in %" } },
                              [
                                _c("el-input-number", {
                                  attrs: { size: "mini" },
                                  model: {
                                    value: _vm.priceArr.price1,
                                    callback: function($$v) {
                                      _vm.$set(_vm.priceArr, "price1", $$v)
                                    },
                                    expression: "priceArr.price1"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-4" },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "Preis 2 in %" } },
                              [
                                _c("el-input-number", {
                                  attrs: { size: "mini" },
                                  model: {
                                    value: _vm.priceArr.price2,
                                    callback: function($$v) {
                                      _vm.$set(_vm.priceArr, "price2", $$v)
                                    },
                                    expression: "priceArr.price2"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-4" },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "Preis 3 in %" } },
                              [
                                _c("el-input-number", {
                                  attrs: { size: "mini" },
                                  model: {
                                    value: _vm.priceArr.price3,
                                    callback: function($$v) {
                                      _vm.$set(_vm.priceArr, "price3", $$v)
                                    },
                                    expression: "priceArr.price3"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("h4", { staticClass: "mt-3" }, [
                        _vm._v("Preismatrix")
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.priceArr.texts, function(text, key) {
                        return _c("offer-template-part-text", {
                          key: "texts-" + key,
                          attrs: {
                            text: text,
                            "price-cols": _vm.priceArr.priceCols
                          }
                        })
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text-right mt-4" },
                        [
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.addTextCol()
                                }
                              }
                            },
                            [_vm._v("neue Zeile")]
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "success" },
                  on: {
                    click: function($event) {
                      return _vm.submitForm("offerTemplatePart")
                    }
                  }
                },
                [_vm._v("Speichern")]
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-portlet__head" }, [
      _c("div", { staticClass: "m-portlet__head-caption" }, [
        _c("div", { staticClass: "m-portlet__head-title" }, [
          _c("h3", { staticClass: "m-portlet__head-text" }, [
            _vm._v(
              "\n                    Neuer Angebotsvorlagen Text\n                "
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }